import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col
} from "reactstrap";

import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import axios from "axios";

import { PanelHeader, Statistics, Button, AnimatedProgressProvider } from "components";

import { thead, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";
import { easeQuadInOut } from "d3-ease";

var dashboardOrdersTitleStyle = {
  margin: "0 0 20px 20px",
  color: "#FFF"
};

class MobileList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas"
    };
    if (this.props.mainState.debug) console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.createUsageProgress = this.createUsageProgress.bind(this);
    this.createMobileCards = this.createMobileCards.bind(this);
  }
  downloadBill(url, orderNumber, event) {
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: "GET",
      responseType: "blob" // important
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  hideDetail() {
    this.setState({
      showDetail: false
    });
  }
  paymentStatus(payment) {
    let statusReady = null;
    if (payment.includes("Pendiente")) {
      statusReady = (
        <Button color="danger" size="sm">
          <i className="now-ui-icons ui-1_simple-remove" /> {payment}
        </Button>
      );
    } else {
      statusReady = (
        <Button color="primary" size="sm">
          <i className="now-ui-icons ui-1_check" /> {payment}
        </Button>
      );
    }

    return statusReady;
  }
  downloadButton(order) {
    let button = (
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>
    );

    if (this.state[order]) {
      button = (
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>
      );
    }

    return button;
  }
  viewOrderArticles(order) {
    let orderDetailContent = (
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">Concepto</th>
              <th className="text-center">Precio</th>
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    });
  }
  remainingUsage(usage, type, maxUsage) {
    let remainingUsage = 0;
    maxUsage = parseFloat(maxUsage);
    switch (type) {
      case "Llamadas":
        remainingUsage = maxUsage - Math.ceil(usage / 60);
        break;
      case "Datos":
        remainingUsage = (maxUsage * 1024 - usage / (1024 * 1024)) / 1024;
        break;
    }
    return remainingUsage;
  }
  getMaxUsageByType(mobile, currentDescription) {
    switch (currentDescription) {
      case "Llamadas":
        return parseFloat(mobile.minutos);
      case "Datos":
        return parseFloat(mobile.gigas);
      default:
        return 0;
    }
  }
  getRemainingUsageTextByType(remainingUsage, currentDescription) {
    switch (currentDescription) {
      case "Llamadas":
        return (
          <div style={{textAlign:"center", lineHeight: "17px"}}>
            <span style={{fontSize:10}}>Quedan</span><br />
            <span style={{fontSize:20, fontWeight:"bold"}}>{Math.round(remainingUsage).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</span><br />
            <div style={{marginTop:-5}}><span style={{fontSize:10}}>minutos</span></div>
          </div>
        );
      case "Datos":
        remainingUsage = String(remainingUsage);
        if (!remainingUsage.includes("."))
          remainingUsage = remainingUsage + ".00";
        remainingUsage = remainingUsage
          .substring(
            0,
            remainingUsage.indexOf(".") > 0
              ? remainingUsage.indexOf(".") + 3
              : remainingUsage.length
          )
          .replace(".", ",");
        return (
          <div style={{textAlign:"center", lineHeight: "17px"}}>
            <span style={{fontSize:10}}>Quedan</span><br />
            <span style={{fontSize:20, fontWeight:"bold"}}>
              {remainingUsage}
              {/* <span style={{fontSize:10}}>GB</span> */}
            </span><br />
            <div style={{marginTop:-5}}><span style={{fontSize:10}}>gigas</span></div>
            
          </div>);
      default:
        return 0;
    }
  }
  createUsageProgress(mobile) {
    let usageCreated = null;
    if (this.props.mainState.mobilesCDRLoaded) {
      // console.log("############# CDR ################");
      // console.log(this.props.mainState.mobilesCDR);
      // usageProgress = Object.keys(
      //   this.props.mainState.mobilesCDR[mobile.mobile][0].cdr
      // ).map(currentDescription => {
      let CDR = this.props.mainState.mobilesCDR[mobile.mobile][0];
      // console.log("############# CDR movil actual ################");
      // console.log(CDR);
      let dataUsage = undefined;
      if (mobile.gigas > 0) {
        let currentCDRType = "Datos";
        let currentCDR = CDR.cdr[currentCDRType];
        // console.log("############# CDR tipo actual ################");
        // console.log(currentCDR);
        let usage = 0.0;
        if (currentCDR !== undefined) {
          currentCDR.map(
            thisRegistry => {
              usage += parseFloat(thisRegistry.consumo);
            }
          );
        }
        if (parseInt(mobile.mobile) in this.props.mainState.todayDataUsage) {
          try {
            let todayUsage = this.props.mainState.todayDataUsage[parseInt(mobile.mobile)];
            if (!todayUsage) {
              todayUsage = [];
            } else {
              usage = 0.0;
            }
            todayUsage.map(todayUsageElemen => {
              usage += parseFloat(todayUsageElemen.trafficUnits);
            });
          } catch (error) {
            // console.error(error);
          }
        }
        let maxUsage = this.getMaxUsageByType(mobile, currentCDRType);
        let remainingUsage = this.remainingUsage(usage, currentCDRType, maxUsage);
        let usageText = this.getRemainingUsageTextByType(remainingUsage, currentCDRType);
        dataUsage = (
          <Col key={currentCDRType} xs={12} md={3}>
            <ProgressWrapper label="Counterclockwise">
              <AnimatedProgressProvider
                valueStart={maxUsage}
                valueEnd={remainingUsage}
                duration={1.4}
                easingFunction={easeQuadInOut}
              >
                {value => {
                  const roundedValue = /* Math.round(value); */ value;
                  return (
                    <CircularProgressbarWithChildren
                      value={value}
                      maxValue={maxUsage}
                      counterClockwise
                      strokeWidth={12}
                      styles={buildStyles({
                        textColor: "black",
                        pathColor: (currentCDRType === "Datos") ? "#5279bf" :"#46B98A",
                        trailColor: "#D8D9DD",
                        pathTransition: "none"
                      })}
                    >
                      {this.getRemainingUsageTextByType(roundedValue, currentCDRType)}
                    </CircularProgressbarWithChildren>
                    /* <CircularProgressbar
                      value={value}
                      text={this.getRemainingUsageTextByType(roundedValue, currentDescription)}
                      /* This is important to include, because if you're fully managing the
                animation yourself, you'll want to disable the CSS animation. 
                      styles={buildStyles({ pathTransition: "none" })}
                    /> */
                  );
                }}
                {/* usageText */}
              </AnimatedProgressProvider>
            </ProgressWrapper>
          </Col>
        );
      }
      
      let voiceUsage = undefined;
      if (mobile.minutos > 0) {
        let currentCDRType = "Llamadas";
        let currentCDR = CDR.cdr[currentCDRType];
        let usage = 0.0;
        if (currentCDR !== undefined) {
          currentCDR.map(
            thisRegistry => {
              usage += parseFloat(thisRegistry.consumo);
            }
          );
        }
        let maxUsage = this.getMaxUsageByType(mobile, currentCDRType);
        let remainingUsage = this.remainingUsage(usage, currentCDRType, maxUsage);
        let usageText = this.getRemainingUsageTextByType(remainingUsage, currentCDRType);
        voiceUsage = (
          <Col key={currentCDRType} xs={12} md={3}>
            <ProgressWrapper label="Counterclockwise">
              <AnimatedProgressProvider
                valueStart={maxUsage}
                valueEnd={remainingUsage}
                duration={1.4}
                easingFunction={easeQuadInOut}
              >
                {value => {
                  const roundedValue = /* Math.round(value); */ value;
                  return (
                    <CircularProgressbarWithChildren
                      value={value}
                      maxValue={maxUsage}
                      counterClockwise
                      strokeWidth={12}
                      styles={buildStyles({
                        textColor: "black",
                        pathColor: (currentCDRType === "Datos") ? "#5279bf" :"#46B98A",
                        trailColor: "#D8D9DD",
                        pathTransition: "none"
                      })}
                    >
                      {this.getRemainingUsageTextByType(roundedValue, currentCDRType)}
                    </CircularProgressbarWithChildren>
                    /* <CircularProgressbar
                      value={value}
                      text={this.getRemainingUsageTextByType(roundedValue, currentDescription)}
                      /* This is important to include, because if you're fully managing the
                animation yourself, you'll want to disable the CSS animation. 
                      styles={buildStyles({ pathTransition: "none" })}
                    /> */
                  );
                }}
                {/* usageText */}
              </AnimatedProgressProvider>
            </ProgressWrapper>
          </Col>
        );
      }
      usageCreated = [dataUsage, voiceUsage];
      // });
    } else {
      usageCreated = 
        <Col xs={12} md={9}>
          <Statistics
            showIcon
            iconState="default"
            icon="now-ui-icons arrows-1_refresh-69 spin"
            title="Móviles"
            subtitle="Cargando..."
          />
        </Col>;
    }
    return usageCreated;
  }
  createUsageProgressBak(mobile) {
    let usageProgress = null;
    if (this.props.mainState.mobilesCDRLoaded) {
      console.log("############# KEYS TIPO CDR ################");
      console.log(this.props.mainState.mobilesCDR);
      usageProgress = Object.keys(
        this.props.mainState.mobilesCDR[mobile.mobile][0].cdr
      ).map(currentDescription => {
        let usage = 0.0;
        this.props.mainState.mobilesCDR[mobile.mobile][0].cdr[currentDescription].map(
          currentCDR => {
            usage += parseFloat(currentCDR.consumo);
          }
        );
        let maxUsage = this.getMaxUsageByType(mobile, currentDescription);
        let remainingUsage = this.remainingUsage(usage, currentDescription, maxUsage);
        let usageText = this.getRemainingUsageTextByType(remainingUsage, currentDescription);
        return (
          <Col key={currentDescription} xs={12} md={3}>
            <ProgressWrapper label="Counterclockwise">
              <AnimatedProgressProvider
                valueStart={maxUsage}
                valueEnd={remainingUsage}
                duration={1.4}
                easingFunction={easeQuadInOut}
              >
                {value => {
                  const roundedValue = /* Math.round(value); */ value;
                  return (
                    <CircularProgressbarWithChildren
                      value={value}
                      maxValue={maxUsage}
                      counterClockwise
                      strokeWidth={12}
                      styles={buildStyles({
                        textColor: "black",
                        pathColor: (currentDescription === "Datos") ? "#5279bf" :"#46B98A",
                        trailColor: "#D8D9DD",
                        pathTransition: "none"
                      })}
                    >
                      {this.getRemainingUsageTextByType(roundedValue, currentDescription)}
                    </CircularProgressbarWithChildren>
                    /* <CircularProgressbar
                      value={value}
                      text={this.getRemainingUsageTextByType(roundedValue, currentDescription)}
                      /* This is important to include, because if you're fully managing the
                animation yourself, you'll want to disable the CSS animation. 
                      styles={buildStyles({ pathTransition: "none" })}
                    /> */
                  );
                }}
                {/* usageText */}
              </AnimatedProgressProvider>
            </ProgressWrapper>
          </Col>
        );
      });
    } else {
      usageProgress = 
        <Col xs={12} md={9}>
          <Statistics
            showIcon
            iconState="default"
            icon="now-ui-icons arrows-1_refresh-69 spin"
            title="Móviles"
            subtitle="Cargando..."
          />
        </Col>;
    }
    return usageProgress;
  }
  createMobileCards() {
    let mobileContent = null;
    if (this.props.mainState.hasMobile && this.props.mainState.mobilesLoaded) {
      mobileContent = this.props.mainState.mobiles.map((currentMobile, key) => {
        return (
          <Row key={currentMobile.mobile}>
            <Col xs={12} md={12}>
              <Card className="card-stats card-raised">
                <CardBody>
                  <Row>
                    <Col xs={12} md={3}>
                      <Link to={this.props.mainState.mobilesCDRLoaded ? "/movil/" + currentMobile.mobile : "/movil"}>
                        <Statistics
                          showIcon
                          iconState="primary"
                          icon="tech_mobile"
                          title={
                            currentMobile.mobile.substring(0, 3) +
                            " " +
                            currentMobile.mobile.substring(3, 6) +
                            " " +
                            currentMobile.mobile.substring(6, 9)
                          }
                          subtitle={currentMobile.plan.replace(" (Móvil)", "")}
                        />
                      </Link>
                    </Col>
                    {this.createUsageProgress(currentMobile)}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      });
    } else if (this.props.mainState.mobilesLoaded) {
      mobileContent = (
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="tech_mobile"
                    title="Móviles"
                    subtitle="¡Trae tus móviles!"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    } else {
      mobileContent = (
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Móviles"
                    subtitle="Cargando..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }
    return mobileContent;
  }
  render() {
    let value = 3;

    return (
      <div>
        <PanelHeader
          content={
            <div className="header text-center">
              <h2 className="title">Lista de móviles</h2>
              <p className="category">Aquí encontrarás el listado de móviles</p>
            </div>
          }
        />
        <div className="content">
          {/* <Row>
            <Col xs={12} md={12}>
              <Card className="card-stats card-raised">
                <CardBody> */}
                    {this.createMobileCards()}
                {/* </CardBody>
              </Card>
            </Col>
          </Row> */}
          <Row>
            {/* <ProgressWrapper label="Counterclockwise">
              <CircularProgressbar
                value={value}
                maxValue={12}
                text={`${value}GB`}
                counterClockwise
                styles={buildStyles({
                  textColor: "red",
                  pathColor: "#46B98A",
                  trailColor: "gold"
                })}
              />
            </ProgressWrapper> */}
            {/* this.createMobileCards() */}
          </Row>
        </div>
      </div>
    );
  }
}

function ProgressWrapper(props) {
  return (
    <div className="statistics" style={{ textAlign: "-webkit-center" }} >
      <div /* style={{ marginTop: 30, display: "flex" }} */>
        <div style={{ width: 100 }}>{props.children}</div>
        {/* <div style={{ marginLeft: 30 }}>
          <h3 className="h5">{props.label}</h3>
          <p>{props.description}</p>
        </div> */}
      </div>
    </div>
  );
}

export default MobileList;



// WEBPACK FOOTER //
// ./src/views/Mobiles/MobilesList.jsx